/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostJourneysSearchJourneyResponseFrequentFlyerCard } from './postJourneysSearchJourneyResponseFrequentFlyerCard';

export interface PostJourneysSearchJourneyResponse {
  /**
   * チェックイン先システム<br> SPACE:SPACEシステム（SPACE）, iCAS: iCAS（国際線ASW(iCAS)）, able-D: able-D（国内線ASW(able-D)）, partnerSite: 提携他社サイト
   */
  checkinSystem: PostJourneysSearchJourneyResponse.CheckinSystemEnum;
  /**
   * 旅程ID
   */
  journeyId?: string;
  /**
   * 暗号化済み国内線ASW連携パラメータ(チェックイン先システムが国内線ASW(able-D)の場合のみ返却)
   */
  encryptedDomesticAswParameter?: string;
  /**
   * キャリアコード(チェックイン先システムが提携他社サイトの場合のみ返却)
   */
  carrierCode?: string;
  frequentFlyerCard?: PostJourneysSearchJourneyResponseFrequentFlyerCard;
}
export namespace PostJourneysSearchJourneyResponse {
  export type CheckinSystemEnum = 'SPACE' | 'iCAS' | 'able-D-ANA' | 'able-D-partner' | 'partnerSite';
  export const CheckinSystemEnum = {
    Space: 'SPACE' as CheckinSystemEnum,
    ICas: 'iCAS' as CheckinSystemEnum,
    AbleDANA: 'able-D-ANA' as CheckinSystemEnum,
    AbleDPartner: 'able-D-partner' as CheckinSystemEnum,
    PartnerSite: 'partnerSite' as CheckinSystemEnum,
  };
}
